/**
 * Custom logger utility that conditionally logs based on environment.
 * In production, logging is suppressed. In development, all logs are shown.
 */

class Logger {
  private isDevelopment: boolean;

  constructor() {
    // Check if we're in development mode
    // Vite apps use VITE_ prefix for environment variables
    this.isDevelopment = 
      import.meta.env.VITE_ENV === 'development';
  }

  /**
   * Standard logger.l replacement
   */
  log(...args: any[]): void {
    if (this.isDevelopment) {
      console.log(...args);
    }
  }

  /**
   * Console.info replacement
   */
  info(...args: any[]): void {
    if (this.isDevelopment) {
      console.info(...args);
    }
  }

  /**
   * Console.warn replacement
   * Note: Warnings are shown in all environments as they indicate potential issues
   */
  warn(...args: any[]): void {
    console.warn(...args);
  }

  /**
   * Console.error replacement
   * Note: Errors are shown in all environments for debugging production issues
   */
  error(...args: any[]): void {
    console.error(...args);
  }

  /**
   * Console.debug replacement
   */
  debug(...args: any[]): void {
    if (this.isDevelopment) {
      console.debug(...args);
    }
  }

  /**
   * Check if logging is enabled
   */
  isEnabled(): boolean {
    return this.isDevelopment;
  }

  /**
   * Force log in any environment (use sparingly)
   */
  force(...args: any[]): void {
    console.log(...args);
  }
}

// Export a singleton instance
export const logger = new Logger();

// Export as default for easier imports
export default logger;
